module.exports = __webpack_public_path__ + "img/Antonia&Stephan-12.efdae4fa.jpg";